'use strict';

import { Entity } from '../Entities/Entity';

export class EntityCollection<TEntity> {
  protected items: TEntity[] = [];
  protected total: number | undefined;
  protected limit: number | undefined;
  protected offset: number | undefined;

  public getTotalItems() {
    return this.items ? this.items.length : 0;
  }

  public setTotal(total: number): this {
    this.total = total;
    return this;
  }

  public getTotal(): number {
    return this.total;
  }

  public setOffset(offset: number): this {
    this.offset = offset;
    return this;
  }

  public getOffset(): number {
    return this.offset;
  }

  public setLimit(limit: number): this {
    this.limit = limit;
    return this;
  }

  public getLimit(): number {
    return this.limit;
  }

  public setItems(items: TEntity[]): this {
    this.items = items;
    return this;
  }

  public addItem(item: TEntity): this {
    this.items.push(item);
    return this;
  }

  public getItems(): TEntity[] {
    return this.items;
  }

  public getItem(index: number): TEntity {
    return this.items[index];
  }

  public removeItem(index: number): this {
    delete this.items[index];
    return this;
  }
}
